
























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    getPrograms,
    deleteOption,
    patchOption,
    getOptions,
    getOptionsPrescriber,
} from '@/api/api';
import MetaDatatable from '@/models/MetaDatatable';
import HeaderDatatable from '@/models/HeaderDatatable';
import User from '@/models/User';
import get from 'lodash/get';
import { roles, formatRoles } from '@/data/roles';
import PaginationDatatable from '@/models/PaginationDatatable';
import SorterDatatable from '@/models/SorterDatatable';
import Program from '@/models/Program';
import OptionModel from '@/models/OptionModel';
import moment from 'moment';
import { Role } from '@/models/Role';
import AuthModule from '@/store/AuthModule';
import { fetchPrescriberOption, fetchProgramOption, fetchStatus,fetchProspectsAdminOption, fetchOperatorsOption } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import { optionStatus } from '@/data/optionStatus';
import SidebarModule from '../store/SidebarModule';
import formatCustomer from '@/utils/formatCustomer';
// @ts-ignore
import localeFr from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import cloneDeep from 'lodash/cloneDeep';
import Denounce from '@/models/Denounce';
import Boolean from "@/components/Boolean.vue";

@Component({
    components: {
        Datatable,
        FilterComponent,
        Boolean,
    },
    filters: {
        formatCustomer,
        formatRemainingHours(value: string) {
          let datetime: any = new Date( value ).getTime();
          let now: any = new Date().getTime();
          if (datetime > now) {
            var diff =(datetime - now) / 1000;
            diff /= (60 * 60);
            return Math.abs(Math.round(diff)) + 'h';
          }else{
            return '0';
          }
          /*const timeDiff: any = moment.duration(
              <any>moment() - <any>moment(value)
          );
          return timeDiff.hours();*/
        },
        formatPrice(value: number) {
            return (
                value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'
            );
        },
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDateHour: (value: string) => {
            return value ? moment(value).format('LT') : null;
        },
        fluxFormat: (value: boolean) => {
          if (value){
            return 'OUI';
          }else{
            return 'NON';
          }
        }
    },
})
export default class Options extends Vue {
    delete_comments: string = '';
    showDeleteCommentsPopUp: boolean = false;

    // Popup de détail/édition du commentaire (delete_comments)
    commentPopupVisible: boolean = false;
    commentPopupRecord: OptionModel | null = null;
    commentPopupText: string = '';
    commentPopupDraft: string = '';
    commentPopupEditing: boolean = false;
    commentPopupSaving: boolean = false;
    option: OptionModel | null = null;
    operatorModel: string | undefined | null = null;
    yearModel: string = 'all';

    moment = moment;
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            customer: undefined,
            operator: undefined,  
            year: null
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    get columns(): HeaderDatatable[] {
        if (this.roles.includes('ROLE_ADMIN')) {
            return [
                {
                  title: 'Date option',
                  dataIndex: 'created_at',
                  scopedSlots: {
                    customRender: 'date',
                  },
                  sorter:true,
                },
                {
                    title: 'Prescripteur',
                    dataIndex: 'customer.prescriber',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'prescriber',
                    },
                },
                {
                    title: 'Statut prescripteur',
                    dataIndex: 'customer.prescriber.family',
                    sorter: true,
                },
                {
                  title: 'Prospect acquéreur',
                  dataIndex: 'customer',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'customer',
                  },
                },
                {
                    title: 'Opérateur',
                    dataIndex: 'operator',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'operator',
                    },
                },
                {
                  title: 'Statut',
                  dataIndex: 'status',
                  scopedSlots: {
                    customRender: 'status',
                  },
                  sorter:true,
                },
                {
                  title: 'Termine dans',
                  dataIndex: 'end_at',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'end_at',
                  },
                },
                {
                  title: 'Proroger',
                  dataIndex: '_end_at',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'extend',
                  },
                },
                {
                    title: 'Programme',
                    dataIndex: 'lot.program',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'program',
                    },
                },
                {
                    title: 'Promoteur',
                    dataIndex: 'lot.program.promoter',
                    scopedSlots: {
                        customRender: 'promoter',
                    },
                },
                
                /*{
                  title: 'Flux Connecté',
                  dataIndex: 'lot.program.promoter.api_connected',
                  sorter: false,
                  scopedSlots: {
                    customRender: 'boolean',
                  },
                },*/

                {
                  title: 'Date Sauv MAJ',
                  dataIndex: 'updated_at',
                  sorter: false,
                  scopedSlots: {
                    customRender: 'date',
                  },
                },
                {
                    title: 'Lot',
                    dataIndex: 'lot',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'lot',
                    },
                },
                {
                    title: 'Ville du bien',
                    dataIndex: 'lot.program.address.city',
                    sorter:true,
                },
                {
                    title: 'Tx commission NOUS',
                    dataIndex: 'denounce.taux_commission',
                    scopedSlots: {
                        customRender: 'commission',
                    },
                    sorter: true,
                },
                {
                    title: 'Prix du bien',
                    dataIndex: 'lot.price',
                    scopedSlots: {
                        customRender: 'price',
                    },
                    sorter:true,
                },
                {
                    title: 'Commentaire',
                    dataIndex: 'delete_comments',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'comment',
                    },
                },
                {
                    title: 'Actions',
                    dataIndex: 'action',
                    scopedSlots: {
                        customRender: 'actions',
                    },
                    fixed: 'right',
                },
            ];
        } else {
            return [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    sorter: true,
                },
                {
                    title: 'Programme',
                    dataIndex: 'lot.program',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'program',
                    },
                },
                {
                    title: 'Lot',
                    dataIndex: 'lot',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'lot',
                    },
                },
                {
                    title: 'Client',
                    dataIndex: 'customer',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'customer',
                    },
                },
                {
                    title: 'Ville du bien',
                    dataIndex: 'lot.program.address.city',
                },
                {
                    title: 'Prix du bien',
                    dataIndex: 'lot.price',
                    scopedSlots: {
                        customRender: 'price',
                    },
                },
                {
                    title: 'Date option',
                    dataIndex: 'created_at',
                    scopedSlots: {
                        customRender: 'date',
                    },
                },
                {
                    title: 'Statut',
                    dataIndex: 'status',
                    scopedSlots: {
                        customRender: 'status',
                    },
                },
                {
                    title: 'Termine dans',
                    dataIndex: 'end_at',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'end_at',
                    },
                },
                {
                    title: 'Proroger',
                    dataIndex: '_end_at',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'extend',
                    },
                },
                {
                    title: 'Statut prescripteur',
                    dataIndex: 'user.family',
                    scopedSlots: {
                        customRender: 'user.family',
                    },
                    fixed: 'right',
                },
            ];
        }
    }

    async fetch(meta: MetaDatatable) {
        if (this.roles.includes('ROLE_ADMIN')) {
            const { data } = await getOptions({
                ...meta,
                page: meta.page - 1,
            });
            data._end_at = data.end_at; // Trick to avoid duplicate key in ant-design Table
            return data;
        } else {
            const { data } = await getOptionsPrescriber({
                ...meta,
                page: meta.page - 1,
            });
            data._end_at = data.end_at;
            return data;
        }
    }

    get optionStatusArr() {
        return Object.keys(optionStatus).map(key => ({
            text: (optionStatus as any)[key],
            value: key,
        }));
    }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years: { text: string; value: string }[] = [
            { text: 'Tous', value: 'all' }
        ];
        for (let year = currentYear; year >= 2021; year--) {
            years.push({ text: year.toString(), value: year.toString() });
        }
        return years;
    }

    @Watch('yearModel', { immediate: true })
    onYearModel() {
        this.meta.filters = {
            ...this.meta.filters,
            year: this.yearModel === 'all' ? null : this.yearModel
        };
    }

    deleteText = {
        confirm: {
            title: `Suppression de l'option`,
            content: `Voulez-vous vraiment supprimer l'option ?`,
        },
        notify: {
            title: 'Option supprimé',
            content: `L'option a bien été supprimé`,
        },
    };
    editText = {
        notify: {
            title: 'Option modifiée',
            content: `L'option a bien été modifiée`,
        },
    };

    get roles(): Role[] {
        return AuthModule.roles;
    }

    // Add this to your computed properties
    get fetchOperator() {
        return fetchOperatorsOption;
    }


    // Prescibers
    get fetchPrescriber() {
        return fetchPrescriberOption;
    }

    // Programs
    get fetchPrograms() {
        return fetchProgramOption;
    }

    get fetchStatus() {
        return fetchStatus;
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: OptionModel | null;
    }) {
        const $vs = (this as any).$vs;
        const action = ev.action;
        const option: OptionModel | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (option && option.id) {
                    let editStatus = {
                        status: option.status,
                        endAt: option.end_at,
                    };

                    if(option && option.id && option.delete_comments) {
                        //@ts-ignore
                        editStatus.delete_comments = option.delete_comments
                    }

                    try {
                        await patchOption(option.id, editStatus);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: this.editText.notify.title,
                            text: this.editText.notify.content,
                        });
                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la modification de l'option`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }
                break;
            case 'delete':
                if (option && option.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };

                    try {
                        await deleteOption(option.id);

                        $vs.notify({
                            color: 'success',
                            position: 'top-right',
                            title: this.deleteText.notify.title,
                            text: this.deleteText.notify.content,
                        });

                        const $datatable = this.$refs.datatable as Datatable;
                        $datatable.refresh();
                    } catch (error) {
                        const message = get(
                            error,
                            'response.data.message',
                            `Erreur lors de la suppression de l'option`
                        );

                        $vs.notify({
                            color: 'danger',
                            position: 'top-right',
                            title: 'Erreur',
                            text: message,
                        });
                    }
                }
                break;
        }

        await SidebarModule.fetchPendingOptions();
    }


    async setDefaultOperatorFilter() {
                try {
                    // Get the current user ID from AuthModule
                    const currentUserId = AuthModule.userID;
                    
                    if (!currentUserId || currentUserId === -1) {
                        this.operatorModel = undefined;
                        console.log('No current user logged in');
                        return;
                    }

                    // Check if current user is in the list of operators for denounces
                    const operators = await fetchOperatorsOption(''); // Get all operators
                    
                    // Look for current user in the operators list - FIX: Add type annotation
                    const isCurrentUserAnOperator = operators.some((operator: any) => 
                        operator.value === currentUserId
                    );

                    if (isCurrentUserAnOperator) {
                        // Set the operator filter to current user
                        this.operatorModel = currentUserId.toString();
                        
                        // Also update the meta filters immediately
                        this.meta.filters = {
                            ...this.meta.filters,
                            operator: currentUserId
                        };
                        
                        console.log('Auto-filtered to current user operator:', AuthModule.firstname, AuthModule.lastname);
                    } else {
                        this.operatorModel = undefined;
                        console.log('Current user is not an operator in denounces');
                    }
                    
                } catch (error) {
                    console.log('Error setting default operator filter:', error);
                    this.operatorModel = undefined;
                }
            }



    getCommissionDisplay(tauxCommission: any): string {
        if (tauxCommission === null || tauxCommission === undefined || tauxCommission === '') {
            return 'NC';
        }

        const value = Number(tauxCommission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    truncateComment(text: string): string {
        if (!text) {
            return '';
        }

        const firstLine = text.split('\n')[0].trim();
        const truncated = firstLine.length > 20 ? firstLine.substring(0, 20).trim() : firstLine;

        return truncated.length < text.length ? `${truncated}…` : truncated;
    }

    appendAdminComment(existingComment: string, adminComment: string): string {
        const userName = AuthModule.firstname || '';
        const userLastName = AuthModule.lastname || '';
        const fullName = `${userName} ${userLastName}`.trim();
        const currentDate = new Date().toLocaleDateString('fr-FR');

        let cleanedComment = existingComment || '';

        if (cleanedComment.trim() && !cleanedComment.endsWith('\n')) {
            cleanedComment += '\n';
        }

        if (fullName) {
            cleanedComment += `Commentaire de ${fullName} le ${currentDate} :\n${adminComment}\n\n`;
        } else {
            cleanedComment += `Commentaire administrateur le ${currentDate} :\n${adminComment}\n\n`;
        }

        return cleanedComment;
    }

    openCommentPopup(record: OptionModel) {
        this.commentPopupRecord = record;
        this.commentPopupText = record.delete_comments || '';
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = false;
        this.commentPopupVisible = true;
    }

    closeCommentPopup() {
        this.commentPopupEditing = false;
        this.commentPopupRecord = null;
    }

    startEditComment() {
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = true;
    }

    cancelEditComment() {
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = false;
    }

    async saveCommentPopup() {
        const $vs = (this as any).$vs;

        if (!this.commentPopupRecord || !this.commentPopupRecord.id) {
            return;
        }

        this.commentPopupSaving = true;
        try {
            const original = this.commentPopupText || '';
            const draft = this.commentPopupDraft;
            let finalText: string;

            if (!original.trim()) {
                finalText = this.appendAdminComment('', draft.trim());
            } else if (draft !== original) {
                const userName = AuthModule.firstname || '';
                const userLastName = AuthModule.lastname || '';
                const fullName = `${userName} ${userLastName}`.trim();
                const currentDate = new Date().toLocaleDateString('fr-FR');

                finalText = draft;
                if (finalText.trim() && !finalText.endsWith('\n')) {
                    finalText += '\n';
                }
                finalText += `${fullName || 'Un utilisateur'} a modifié ce commentaire le ${currentDate}.`;
            } else {
                finalText = draft;
            }

            await patchOption(this.commentPopupRecord.id, {
                delete_comments: finalText,
            } as OptionModel);

            (this.commentPopupRecord as any).delete_comments = finalText;
            this.commentPopupText = finalText;
            this.commentPopupEditing = false;

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Commentaire modifié',
                text: 'Le commentaire a bien été mis à jour',
            });

            const dt: any = (this.$refs && (this.$refs as any).datatable) ? (this.$refs as any).datatable : null;
            if (dt && typeof dt.refresh === 'function') {
                dt.refresh();
            }
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification du commentaire`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.commentPopupSaving = false;
        }
    }

    deleteDialog(option: OptionModel) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(option),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async editStatus(option: OptionModel) {
        if (this.messageError) {
            return;
        }
        if(!this.delete_comments) {
            this.showDeleteCommentsPopUp = true;
            this.delete_comments = option.delete_comments || ' ';
            this.option = option;
            return;
        } else {
            const original = option.delete_comments || '';
            const draft = this.delete_comments;
            let newContent = draft.trim();
            if (original.trim() && draft.startsWith(original)) {
                newContent = draft.substring(original.length).trim();
            }
            option.delete_comments = newContent
                ? this.appendAdminComment(original, newContent)
                : original;
            this.delete_comments = '';
        }
        await this.actionDatatable({ action: 'edit', item: option });
    }

    async acceptDeleteAlert(option: OptionModel) {
        await this.actionDatatable({ action: 'delete', item: option });
    }

    get localeFr() {
        return localeFr;
    }

    async editEndAt(date: moment.Moment, option: OptionModel) {
        const DATE_TIME_PHP = 'YYYY-MM-DDTHH:mm:ssZZ';
        option.end_at = date.format(DATE_TIME_PHP);

        await this.actionDatatable({ action: 'edit', item: option });
    }

    disabledDate(current: moment.Moment) {
        return (
            current &&
            current <
                moment()
                    .subtract(1, 'days')
                    .endOf('day')
        );
    }

    async created() {
        this.prescriberModel = undefined;
        this.programModel = undefined;
        this.statusModel = undefined;
        await this.setDefaultOperatorFilter();
        this.yearModel = 'all';
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;
    programModel: string | undefined | null = null;
    statusModel: string | undefined | null = null;
    statutPrescriberModel: string | undefined | null = null;
    customersModel: string | undefined | null = null;

    get statusPrescripteurValues(){
        return [
            { text: 'CGPi', value: 'CGPi' },
            { text: 'CGP Mandataire', value: 'CGP Mandataire' },
            {
                text: 'Conseiller Immobilier Neuf carte T',
                value: 'Conseiller Immobilier Neuf carte T',
            },
            {
                text: 'Conseiller Immobilier Neuf Mandataire',
                value: 'Conseiller Immobilier Neuf Mandataire',
            },
            { text: 'CIF', value: 'CIF' },
            {
                text: 'Agent Immobilier Ancien Carte T',
                value: 'Agent Immobilier Ancien Carte T',
            },
            {
                text: 'Mandataire Immobilier Ancien',
                value: 'Mandataire Immobilier Ancien',
            },
        ]
    }

    //Customers
    get fetchCustomer(){
        return fetchProspectsAdminOption;
    }


    // Add this to your @Watch methods section
    @Watch('operatorModel', { immediate: true })
    onOperatorModel() {
        if (this.operatorModel) {
            this.meta.filters = {
                ...this.meta.filters,
                operator: this.operatorModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                ...this.meta.filters,
                operator: null
            };
        }
    }



    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.program) {
            this.programModel = this.meta.filters.program;
        } else {
            this.programModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.status) {
            this.statusModel = this.meta.filters.status;
        } else {
            this.statusModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.statusPrescriber) {
            this.statutPrescriberModel = this.meta.filters.statusPrescriber;
        } else {
            this.statutPrescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.customer) {
            this.customersModel = this.meta.filters.customer;
        } else {
            this.customersModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.year) {
            this.yearModel = this.meta.filters.year;
        } else {
            this.yearModel = 'all';
        }


        if (this.meta.filters && this.meta.filters.operator) {
                this.operatorModel = this.meta.filters.operator;
            } else {
                this.operatorModel = undefined;
            }



    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters = {
                prescriber: this.prescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters ={
                prescriber: null
            };
        }
    }

    onStatutPrescriberModel(){

        if (this.statutPrescriberModel) {
            this.meta.filters = {
                statusPrescriber: this.statutPrescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters ={
                statusPrescriber: null
            };
        }
    }
    @Watch('customersModel', { immediate: true })
    onCustomersModel(){
        if (this.customersModel) {
            this.meta.filters= {
                customer: this.customersModel
            };
        } else if (this.meta.filters) {
            this.meta.filters= {
                customer: null
            };
        }
    }

    @Watch('programModel', { immediate: true })
    onProgramModel() {
        if (this.programModel) {
            this.meta.filters = {
                program: this.programModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                program: null
            };
        }
    }

    @Watch('statusModel', { immediate: true })
    onStatusModel() {
        if (this.statusModel) {
            this.meta.filters = {
                status: this.statusModel
            };
        } else if (this.meta.filters) {
            this.meta.filters= {
                status: null
            };
        }
    }
    get messageError() {
        if (this.delete_comments.length > 10000) {
            console.log(this.delete_comments.length)
            return '10000 caractères maximum';
        }

        return null;
    }
}
